import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { setSettingForApp } from 'entities/user/module/app-settings'

import GuardImage from 'shared/images/guard.webp'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { ImageOptimized } from 'shared/ui/image-optimized'

import { INSURANCE_INTRO_SETTING_KEY } from '../../model/constants'
import { InsuranceLayout } from '../../ui/insurance-layout'

import s from './styles.module.scss'

const INTRO_BENEFIT_KEYS = ['online', 'policy', 'visa']

const IntroInsurancePage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleApply = () => {
    setSettingForApp({
      key: INSURANCE_INTRO_SETTING_KEY,
      value: 'seen',
    }).catch(() => undefined)

    navigate(RoutingPaths.insurance.application.path(), { replace: true })
  }

  return (
    <InsuranceLayout
      title={t('insurance.travel')}
      onGoBack={() => navigate(-1)}
    >
      <div className={s.content}>
        <div className={s.hero}>
          <ImageOptimized
            src={GuardImage}
            width={102}
            height={120}
            wrapperClassName={s.shield}
            objectFit="contain"
            priority
          />

          <div className={s.information}>
            <h1 className={clsx(s.title, 'extra-bold-24')}>
              {t('insurance.vzr.intro.title')}
            </h1>

            <div className={s.copy}>
              <p className="regular-14">{t('insurance.vzr.intro.subtitle')}</p>
              <p className="regular-14">
                {t('insurance.vzr.intro.description')}
              </p>
            </div>

            <ul className={s.benefits}>
              {INTRO_BENEFIT_KEYS.map((benefit) => (
                <li
                  key={benefit}
                  className={clsx(s.benefit, 'medium-14')}
                >
                  <AppIcon
                    className={s.benefitIcon}
                    id={AllIcons.CHECK_BOLD}
                    width={16}
                    height={16}
                  />
                  <span>{t(`insurance.vzr.intro.benefits.${benefit}`)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Button
          type="button"
          className={clsx(s.applyButton, 'semi-bold-16')}
          onClick={handleApply}
        >
          {t('insurance.vzr.actions.apply')}
        </Button>
      </div>
    </InsuranceLayout>
  )
}

export default IntroInsurancePage
